import * as React from "react";
import { Modal, Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from 'react-i18next';

export default function ModalGeneric({
  open,
  title,
  description,
  onClose,
  onAccept,
  titleComponent,
  descriptionComponent,
  cancelButtonComponent,
  acceptButtonComponent,
  bodyComponent,
}) {
  const theme = useTheme();
  const { t } = useTranslation();

  const handleAccept = () => {
    if (onAccept) {
      onAccept();
    }
  };

  const handleCancel = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleCancel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: 500,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
        }}
      >
        {titleComponent ? (
          <div>{titleComponent}</div>
        ) : (
          <Typography
            id="modal-modal-title"
            variant="h5 black"
            className="color-primary"
            component="h2"
          >
            {title}
          </Typography>
        )}
        {descriptionComponent ? (
          <div>{descriptionComponent}</div>
        ) : (
          <Typography
            id="modal-modal-description"
            variant="h6"
            component="h2"
            sx={{ mt: 2 }}
          >
            {description}
          </Typography>
        )}
        {bodyComponent && <div>{bodyComponent}</div>}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          {cancelButtonComponent ? (
            <div>{cancelButtonComponent}</div>
          ) : (
            <Button
              sx={{ color: theme.palette.danger.main }}
              onClick={handleCancel}
              variant="text"
            >
              {t("buttons.cancel")}
            </Button>
          )}
          {acceptButtonComponent ? (
            <div>{acceptButtonComponent}</div>
          ) : (
            <Button
              sx={{ color: theme.palette.primary.main, ml: 1 }}
              onClick={handleAccept}
              variant="text"
            >
               {t("buttons.accept")}
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  );
}
